import { render, staticRenderFns } from "./BadgeActionMassDelete.vue?vue&type=template&id=7d3f31ac&"
import script from "./BadgeActionMassDelete.vue?vue&type=script&lang=ts&"
export * from "./BadgeActionMassDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports